// Random motivational messages and event prompts

export const motivationalMessages = [
  "Your couch called. It said you're being boring.",
  "Your friends don't know it yet, but they're waiting for your invite.",
  "Everyone else is pretending to be busy. Be the one who actually does shit.",
  "Your city has stuff in it. Go touch it.",
  "If your social life was a plant, it'd be dead. WATER IT!",
  "You're hot. People want to hang out with you. Act like it.",
  "There's life outside your phone. I promise. Go find it.",
  "You want friends? Plans make friends. Make a plan.",
];

export const eventPrompts = [
  "Bob Ross Night. Don't chicken out.",
  "Paint happy little trees. Badly.",
  "Movie night. No endless scrolling. Pick.",
  "Walk a random street. Be mysterious.",
  "Sunset walk. Your phone can wait.",
  "Restaurant roulette. Point. Go. Deal with it.",
  "Dessert-only night. Because joy.",
  "$10 Thrift Outfit. Wear it proudly, coward.",
  "Bookstore hang. Buy the weirdest book.",
  "Library hour. Touch knowledge, nerd.",
  "Ice cream run. Weather is irrelevant.",
  "Late-night diner vibes. Feel something.",
  "Drive past your high school. Laugh at yourself.",
  "Bike somewhere with no plan.",
  "Dress up. Take photos. Act iconic.",
  "Puzzle + music. Chill your brain.",
  "Board game night. No Monopoly. We're not monsters.",
  "Tea + story night. Overshare responsibly.",
  "Make friendship bracelets. Cry if needed.",
  "Origami night. Fold your feelings.",
  "Candle crafting night. Vibes max.",
  "Sew a button. Become a functioning adult.",
  "Whittle soap. Become a frontier grandma.",
  "Calligraphy night. Pretend you're elegant.",
  "Walk to the nearest park. Touch grass.",
  "Fish in a pond. Catch disappointment.",
  "Tiny hike. No heroics. Just move.",
  "Bike your childhood route. Nostalgia speedrun.",
  "Cloud-watch. Yes, lay on the ground.",
  "Feed the ducks. Don't poison them.",
  "Climb a hill. Claim it as yours.",
  "Parking lot stargaze. Cheap romance.",
  "Surprise party for no reason. Chaos energy.",
  "Off-season caroling. Terrify your neighbors.",
  "Dress fancy for Taco Bell. Own it.",
  "Pet store bird gossip session.",
  "Fake book club meeting. Zero reading allowed.",
  "Write postcards. Be a wholesome menace.",
  "Open house tour. Pretend you're wealthy.",
  "Teach each other dumb skills. Humble yourselves.",
  "24-hour talent show. No shame allowed.",
  "Coffee + walk. Minimal brain required.",
  "Drive nowhere. Talk like humans again.",
  "Sit on a porch and reflect, philosopher.",
  "Target walkabout. No shopping list.",
  "Thrift store mug quest. Go.",
  "Ghibli movie + draw vibes.",
  "Learn to cartoon. Embrace the cringe.",
  "Follow one random YouTube tutorial. No backing out.",
  "Potluck snack night. Bring chaos food.",
  "DIY sushi night. It will look awful.",
  "Learn one magic trick. Become unbearable.",
  "Blindfold taste test. Suffer cutely.",
  "Make a TikTok dance. Never post it.",
  "Draw each other horribly. Frame it proudly.",
  "Blanket fort. Become children again.",
  "Make a zine in an hour.",
  "Learn to juggle. Drop everything.",
];

/**
 * Get a random motivational message
 */
export const getRandomMotivationalMessage = () => {
  return motivationalMessages[Math.floor(Math.random() * motivationalMessages.length)];
};

/**
 * Get a random event prompt
 */
export const getRandomEventPrompt = () => {
  return eventPrompts[Math.floor(Math.random() * eventPrompts.length)];
};



